// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bulletTextArea {
    &[contenteditable='true']:empty:before {
        content: attr(placeholder);
        color: #aaa;
        pointer-events: none;
        display: block;
    }
}

.form-item-custom-validation.ant-form-item-has-error .bulletTextAreaWrapper {
    border-color: red;
}
`, "",{"version":3,"sources":["webpack://./src/library/form-wizard/form-wizard.css"],"names":[],"mappings":"AAAA;IACI;QACI,0BAA0B;QAC1B,WAAW;QACX,oBAAoB;QACpB,cAAc;IAClB;AACJ;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":[".bulletTextArea {\n    &[contenteditable='true']:empty:before {\n        content: attr(placeholder);\n        color: #aaa;\n        pointer-events: none;\n        display: block;\n    }\n}\n\n.form-item-custom-validation.ant-form-item-has-error .bulletTextAreaWrapper {\n    border-color: red;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
